export function isIOS(): boolean {
	if (typeof window === 'undefined') return false;
	return (
		/iPad|iPhone|iPod/.test(window.navigator.userAgent) ||
		(navigator.platform === 'MacIntel' &&
			(navigator as any).maxTouchPoints > 1)
	); // iPadOS Safari
}

export function isAndroid(): boolean {
	if (typeof window === 'undefined') return false;
	return /Android/.test(window.navigator.userAgent);
}

export function isStandaloneDisplay(): boolean {
	if (typeof window === 'undefined') return false;
	const mq =
		window.matchMedia &&
		window.matchMedia('(display-mode: standalone)').matches;
	const iosStandalone = (window.navigator as any).standalone === true; // iOS Safari
	return mq || iosStandalone;
}

export function isPWAInstalled(): boolean {
	return isStandaloneDisplay();
}
